<template>
  <div class="revalidation-item-skeleton">
    <div class="skeleton-checkbox skeleton-shimmer" />
    <div class="skeleton-fields">
      <div class="skeleton-field">
        <div class="skeleton-label skeleton-shimmer" />
        <div class="skeleton-tag skeleton-shimmer" />
      </div>
      <div class="skeleton-field">
        <div class="skeleton-label skeleton-shimmer" />
        <div class="skeleton-value skeleton-shimmer" />
      </div>
      <div class="skeleton-field">
        <div class="skeleton-label skeleton-shimmer" />
        <div class="skeleton-input skeleton-shimmer" />
      </div>
      <div class="skeleton-field">
        <div class="skeleton-label skeleton-shimmer" />
        <div class="skeleton-input skeleton-shimmer" />
      </div>
      <div class="skeleton-field">
        <div class="skeleton-label skeleton-shimmer" />
        <div class="skeleton-input skeleton-shimmer" />
      </div>
    </div>
    <div class="skeleton-btn skeleton-shimmer" />
  </div>
</template>

<style scoped lang="scss">
.revalidation-item-skeleton {
  @apply flex flex-col w-full gap-4;
  @apply px-4 pt-4 pb-5;
  @apply rounded-md border-a-xs border-neutral-high-medium;
  @apply bg-neutral-high-pure;

  @screen md:system {
    @apply flex-row items-start px-6;
  }

  > .skeleton-checkbox {
    @apply hidden flex-shrink-0 self-center;
    @apply w-[18px] h-[18px] rounded-[4px];

    @screen md:system {
      @apply flex;
    }
  }

  > .skeleton-fields {
    @apply flex flex-col gap-4 w-full;

    @screen md:system {
      @apply flex-row items-start gap-6 flex-1;
    }

    > .skeleton-field {
      @apply flex flex-col gap-2 w-full;

      @screen md:system {
        @apply w-[160px] flex-shrink-0;

        &:nth-child(2) { @apply w-[180px]; }
        &:nth-child(3) { @apply w-[200px]; }
        &:nth-child(4) { @apply flex-1 min-w-[200px]; }
        &:nth-child(5) { @apply flex-1 min-w-[180px]; }
      }

      > .skeleton-label {
        @apply h-[14px] w-[80px] rounded-[4px];
      }

      > .skeleton-tag {
        @apply h-[24px] w-[120px] rounded-full;
      }

      > .skeleton-value {
        @apply h-[20px] w-[140px] rounded-[4px];
      }

      > .skeleton-input {
        @apply w-full h-[36px] rounded-[6px];
      }
    }
  }

  > .skeleton-btn {
    @apply hidden flex-shrink-0 self-center ml-auto;
    @apply w-[32px] h-[32px] rounded-[6px];

    @screen md:system {
      @apply flex;
    }
  }
}

.skeleton-shimmer {
  @apply relative overflow-hidden;
  background-color: #e4e4e4;

  &::after {
    @apply absolute inset-0 w-full h-full;
    content: '';
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.4) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    animation: shimmer 1.5s infinite;
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
</style>
